const TABLE_NAME = "queue";

const TABLE_SCHEMA = "";

export default {
  TABLE_NAME,
  TABLE_SCHEMA,
};
